import { Box, Stack, Typography, Grid, Button, Dialog, DialogContent, DialogTitle, IconButton } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import CustomIcon from "./customIcon";
import DomainIcon from '@mui/icons-material/Domain';
import CurrencyRupeeRoundedIcon from '@mui/icons-material/CurrencyRupeeRounded';
import FmdGoodIcon from '@mui/icons-material/FmdGood';
import AccountBalanceOutlinedIcon from '@mui/icons-material/AccountBalanceOutlined';
import StarBorderRoundedIcon from '@mui/icons-material/StarBorderRounded';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import CloseIcon from '@mui/icons-material/Close';
import { useSnackbar } from "notistack";
import { useSelector } from "react-redux";
import listingTeaserService from "../services/listingTeaser";

const YOUTUBE_ID = /^[\w-]{11}$/;

const toYoutubeEmbedUrl = (input) => {
  const raw = String(input || "").trim();
  if (!raw) return null;

  const iframeSrc = raw.match(/src\s*=\s*["']([^"']+)["']/i);
  const candidate = (iframeSrc?.[1] ?? raw).trim();

  if (YOUTUBE_ID.test(candidate)) {
    return `https://www.youtube.com/embed/${candidate}`;
  }

  let url;
  try {
    url = new URL(candidate);
  } catch {
    return null;
  }

  const host = url.hostname.replace(/^www\./, "").toLowerCase();
  const allowed =
    host === "youtu.be" ||
    host === "youtube.com" ||
    host === "m.youtube.com" ||
    host === "music.youtube.com" ||
    host === "youtube-nocookie.com";
  if (!allowed) return null;

  let id = null;
  if (host === "youtu.be") {
    id = url.pathname.split("/").filter(Boolean)[0] ?? null;
  } else {
    const parts = url.pathname.split("/").filter(Boolean);
    if (parts[0] === "embed" || parts[0] === "shorts" || parts[0] === "live" || parts[0] === "v") {
      id = parts[1] ?? null;
    } else {
      id = url.searchParams.get("v");
    }
  }

  if (!id) return null;
  id = id.split("?")[0]?.split("&")[0] ?? "";
  if (!YOUTUBE_ID.test(id)) return null;
  return `https://www.youtube.com/embed/${id}`;
};
export default function PropertyTeaser({data}){

    const { enqueueSnackbar } = useSnackbar();
    // const [inWatchlist,setInWatchlist] = useState(false);   
    const url = process.env.REACT_APP_SERVER_URL;
    const userId = useSelector(state => state.user.data?._id);
    const [isInterested, setIsInterested] = useState(false);
    const [isSubmittingInterest, setIsSubmittingInterest] = useState(false);
    const [videoOpen, setVideoOpen] = useState(false);

    const hasVideo = data?.isVideo === true || data?.isVideo === "true";
    const videoEmbedUrl = hasVideo ? toYoutubeEmbedUrl(data?.youtubeEmbedLink || "") : null;

    useEffect(() => {
      const hasInterestedFlag = Boolean(
        data?.interestedInvestor || data?.isInterested || data?.interested
      );

      const interestedFromList = Array.isArray(data?.interestedInvestors)
        ? data.interestedInvestors.some((investor) => {
            const investorId =
              typeof investor === "string"
                ? investor
                : investor?.userId || investor?._id;
            return investorId === userId;
          })
        : false;

      setIsInterested(hasInterestedFlag || interestedFromList);
    }, [data, userId]);

    const handleInterestedClick = async (teaserId) =>{
        if (isInterested || isSubmittingInterest) return;
        if (!userId || !teaserId) {
          enqueueSnackbar("Missing user or teaser id", { variant: "error" });
          return;
        }
        setIsSubmittingInterest(true);
        try{
       const payload = {
        userId: userId,
        teaserId: teaserId
       }
       const res = await listingTeaserService.setInterestedTeasers(payload);
       if(res && res.success){
        setIsInterested(true);
        enqueueSnackbar("Interested in the property", {variant: "success"});
       }else{
        enqueueSnackbar("Failed to interested in the property", {variant: "error"});
       }
       }catch(error){
        enqueueSnackbar("Failed to interested in the property", {variant: "error"});
       } finally {
        setIsSubmittingInterest(false);
       }
    }

    const getSubDataIcon = (logoName) => {
      const normalizedLogo = (logoName || "")
        .toString()
        .trim()
        .toLowerCase()
        .replace(/[\s_-]/g, "");

      const iconMap = {
        building2: DomainIcon,
        landmark: AccountBalanceOutlinedIcon,
        indianrupee: CurrencyRupeeRoundedIcon,
        star: StarBorderRoundedIcon,
      };

      return iconMap[normalizedLogo] || DomainIcon;
    };

    const renderValueWithMeta = (item, valueSize = "inherit") => {
      return (
        <>
          {item?.prefix ? (
            <Box component="span" sx={{ fontSize: "0.75em", color: "text.secondary", mr: 0.25 }}>
              {item.prefix}
            </Box>
          ) : null}
          <Box component="span" sx={{ fontSize: valueSize, fontWeight: 600, color: "#333333" }}>
            {item?.value ?? ""}
          </Box>
          {item?.suffix ? (
            <Box component="span" sx={{ fontSize: "0.75em", color: "text.secondary", ml: 0.25 }}>
              {item.suffix}
            </Box>
          ) : null}
        </>
      );
    };
    

    
      function onError(e) {
        e.target.src =
          "assets/icons/poweredby.png";
      }
    return (
      <>
      <Dialog
        open={videoOpen}
        onClose={() => setVideoOpen(false)}
        maxWidth={false}
        sx={{
          "& .MuiDialog-paper": {
            width: { xs: "calc(100vw - 32px)", md: 960 },
            maxWidth: { xs: "calc(100vw - 32px)", md: 960 },
            m: { xs: 2, md: 4 },
          },
        }}
      >
        <DialogTitle sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", pr: 1.5 }}>
          Asset video
          <IconButton
            aria-label="Close video"
            onClick={() => setVideoOpen(false)}
            sx={{
              ml: 1,
              "&:hover": { bgcolor: "action.hover" },
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Box sx={{ position: "relative", width: "100%", aspectRatio: "16 / 9", bgcolor: "#000", borderRadius: 1, overflow: "hidden" }}>
            {videoOpen && videoEmbedUrl ? (
              <iframe
                key={videoEmbedUrl}
                src={`${videoEmbedUrl}?autoplay=1&rel=0`}
                title="Asset video"
                style={{ position: "absolute", inset: 0, width: "100%", height: "100%", border: 0 }}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
              />
            ) : null}
          </Box>
        </DialogContent>
      </Dialog>
      <Stack
        sx={{
          borderRadius: "10px",
          width: { md: 398, xs: "auto" },
          maxWidth: "100%",
          height: { md: 636, xs: 500 },
          cursor: "pointer",
        }}
        className="property-card"
      >
        <Box
          sx={{
            width: "100%",
            height: "49.845%",
            bgcolor: "purple",
            borderRadius: "10px 10px 0px 0px",
            // background:"url('https://images.pexels.com/photos/290275/pexels-photo-290275.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1')",
            background: `url('${data?.url}${data?.listingTeaserImage[0]?.docUrl}')`,
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            position: "relative",
            overflow: "hidden",
          }}
        >
          <Box
            sx={{
              position: "absolute",
              top: 18,
              right: -26,
              width: 140,
              textAlign: "center",
              transform: "rotate(45deg)",
              bgcolor: "#2d6df6",
              color: "#fff",
              py: "6px",
              fontSize: 14,
              fontWeight: 700,
              letterSpacing: "1px",
              textTransform: "uppercase",
              zIndex: 2,
            }}
          >
            Teaser
          </Box>
          <Grid
            style={{
              position: "absolute",
              left: "0",
              top: "0",
              zIndex: "1",
              display: false ? "block" : "none",
            }}
          >
            <img
              src="/assets/images/select_banner.png"
              style={{ height: "109px", width: "115px" }}
              alt="Description of the image"
            />
          </Grid>

          <Stack
            direction={"column"}
            justifyContent={"space-between"}
            sx={{
              position: "absolute",
              width: "100%",
              height: "100%",
              // background: "transparent linear-gradient(180deg, #0000001A 0%, #141E37CC 100%) 0% 0% no-repeat padding-box",
              borderRadius: "10px 10px 0px 0px",
              px: { md: 2, xs: 2 },
              pt: { md: 2, xs: 3 },
              pb: { md: 2, xs: 3 },
            }}
          >
            <Stack
              direction={"row"}
              justifyContent={"space-between"}
              alignItems={"center"}
            >
              <Box
                sx={{
                  background: "#ffffffcc",
                  color: "#000000a3",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "75%",
                  padding: "0px 6px",
                  borderRadius: "5px",
                }}
              >
                <FmdGoodIcon
                  sx={{ fill: "#ea4335", width: "18px", height: "18px" }}
                />
                <Typography variant="miscTab" sx={{ fontWeight: 600 }}>
                  {data?.location}
                </Typography>
              </Box>

              <Box
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                }}
                sx={{
                  borderRadius: "100%",
                  // background:"#ffffff33 0% 0% no-repeat padding-box",
                  width: 36,
                  height: 36,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  padding: 0.5,
                  position: "relative",
                  overflow: "hidden",
                  "&::before": {
                    position: "absolute",
                    width: "100%",
                    height: "100%",
                    borderRadius: "18px",
                    background: "inherit",
                    boxShadow: "inset 0 0 0 200px rgb(255,255,255)",
                    filter: "blur(50px) brightness(12%)",
                    zIndex: 0,
                  },
                }}
              >
              </Box>

            </Stack>
          </Stack>
          {videoEmbedUrl ? (
            <IconButton
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                setVideoOpen(true);
              }}
              aria-label="Play video"
              sx={{
                position: "absolute",
                left: "50%",
                top: "50%",
                transform: "translate(-50%, -50%)",
                zIndex: 3,
                width: 56,
                height: 56,
                bgcolor: "rgba(255,255,255,0.95)",
                color: "primary.main",
                boxShadow: "0 8px 20px rgba(0,0,0,0.18)",
                "&:hover": {
                  bgcolor: "#fff",
                  transform: "translate(-50%, -50%) scale(1.05)",
                },
              }}
            >
              <PlayArrowIcon sx={{ fontSize: 28, ml: 0.25 }} />
            </IconButton>
          ) : null}
        </Box>
        <Stack
          direction={"column"}
          className="property-card-wrapper"
          sx={{
            px: { md: 2, xs: 2 },
            pt: { md: 1, xs: 2 },
            pb: 1,
            flex: 1,
            borderRadius: "0px 0px 10px 10px",
            border: "1px solid",
            borderColor: "divider",
          }}
        >
          <Grid container spacing={2}>
            <Grid item xs={12} style={{ zIndex: "20" }}>
              {data?.isBranded && (
                <div style={{ textAlign: "center" }}>
                  <img
                    src={`${data?.url}${data?.listingTeaserImage[1]?.docUrl}`}
                    onError={(e) => onError(e)}
                    lt="Image 1"
                    style={{
                      width: "5.5rem",
                      height: "5.5rem",
                      minHeight: "5.5rem",
                      maxHeight: "5.5rem",
                      maxWidth: "5.5rem",
                      overflow: "hidden",
                      display: "block",
                      margin: "auto",
                      borderRadius: "50%",
                      backgroundColor: "white",
                      marginTop: "-55px",
                      marginBottom: "5px",
                      objectFit: "cover",
                    }}
                  />
                  <Typography variant="subtitle1">Deal Manager</Typography>
                </div>
              )}
            </Grid>

          </Grid>

          <Typography
            noWrap
            sx={{
              fontSize: 22,
              fontWeight: 500,
              mt: 1,
              textOverflow: "ellipsis",
            }}
          >
            {data?.title}
          </Typography>
          <Typography variant="body2" sx={{ color: "#333333" }}>
            {data?.subTitle}
          </Typography>

          <Grid container spacing={0.5} sx={{ my: 1 }}>
            {data?.mainData?.length == 3 &&
              data?.mainData?.map((item, index) => (
                <Grid
                  item
                  xs={4}
                  sx={{
                    textAlign:
                      index === 0 ? "left" : index === 1 ? "center" : "right",
                  }}
                >
                  <Typography variant="subtitle1">{item?.title}</Typography>

                  <Typography
                    variant="h4"
                    sx={{
                      color: "#333333",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                    title={item?.value}
                  >
                    {renderValueWithMeta(item)}
                  </Typography>
                </Grid>
              ))}
            {data?.mainData?.length == 2 &&
              data?.mainData?.map((item, index) => (
                <Grid xs={6} sx={{ textAlign: index === 0 ? "left" : "right" }}>
                  <Typography variant="subtitle1">{item?.title}</Typography>

                  <Typography variant="h4" sx={{ color: "#333333" }}>
                    {renderValueWithMeta(item)}
                  </Typography>
                </Grid>
              ))}
            {data?.mainData?.length == 1 &&
              data?.mainData?.map((item, index) => (
                <Grid xs={12} sx={{ textAlign: "center" }}>
                  <Typography variant="subtitle1">{item?.title}</Typography>

                  <Typography variant="h4" sx={{ color: "#333333" }}>
                    {renderValueWithMeta(item)}
                  </Typography>
                </Grid>
              ))}

            
          </Grid>

          <Grid
            container
            spacing={2}
            sx={{ my: 1 }}
            className="property-characteristics"
          >
            {data?.subData?.length == 3 &&
              data?.subData?.map((item, index) => {
                const IconComponent = getSubDataIcon(item?.logo);
                return (
                  <Grid xs={4} sx={{ textAlign: "center" }}>
                    <IconComponent color="action" fontSize="small" />
                    <Typography variant="subtitle1">{item?.title}</Typography>
                    <Typography variant="body2">
                      {renderValueWithMeta(item)}
                    </Typography>
                  </Grid>
                );
              })}
              {data?.subData?.length == 2 &&
              data?.subData?.map((item, index) => {
                const IconComponent = getSubDataIcon(item?.logo);
                return (
                  <Grid item xs={6} sx={{ textAlign: index === 0 ? "left" : "right" }}>
                    <IconComponent color="action" fontSize="small" />
                    <Typography variant="subtitle1">{item?.title}</Typography>
                    <Typography variant="body2">
                      {renderValueWithMeta(item)}
                    </Typography>
                  </Grid>
                );
              })}
            {data?.subData?.length == 1 &&
              data?.subData?.map((item, index) => {
                const IconComponent = getSubDataIcon(item?.logo);
                return (
                  <Grid item xs={12} sx={{ textAlign: "center" }}>
                    <IconComponent color="action" fontSize="small" />
                    <Typography variant="subtitle1">{item?.title}</Typography>
                    <Typography variant="body2">
                      {renderValueWithMeta(item)}
                    </Typography>
                  </Grid>
                );
              })}
          </Grid>

          <Grid sx={{ mt: "auto" }}>
            <Stack direction={"column"} spacing={2} sx={{ marginTop: 1 }}></Stack>
            <Button disabled={isInterested || isSubmittingInterest} variant="contained" color="primary" onClick={() => handleInterestedClick(data?._id)} fullWidth>{isInterested ? "Interested" : "Interested"}</Button>   
          </Grid>
        </Stack>
      </Stack>
      </>
    );
}